import css from 'styled-jsx/css';
import { colors, icons } from '../../../../config/styles';
import { svgToDataUri } from '../../../../utils/styles/svgMixins';

const ProductSpecificationsMobileStyle = css`
  .product-specifications {
    display: flex;
    flex-direction: column;
    margin-top: 9px;
    &-column {
      width: 100%;
      height: auto;

      @mixin tabletToDesktop {
        height: 700px;
      }
      .stock-table {
        @mixin mobileToPhablet {
          margin-left: 25px;
        }
      }
      span {
        font-weight: bold;
      }
      .color-swatch-container {
        position: relative;
        @mixin mobileToTablet {
          margin: 15px 0;
        }
        overflow: visible;

        .expand-swatch {
          position: static;
          font-size: 10px;
          margin-top: 8px;
        }
      }
    }
  }
  .flex {
    display: flex;
  }
  .flex > * {
    flex: 1;
  }
  .prices {
    margin-bottom: 12px;
    &.withMultipurposeBadge {
      margin-bottom: 16px;
    }
  }
  .badges {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 0;
    gap: 8px;
    height: fit-content;
    position: relative;
    margin-bottom: 12px;
  }
  .cmr-points {
    font-size: 11px;
    margin-top: 11px;
    color: ${colors.black.shade7};
  }

  .boomIcon {
    background-image: url('${svgToDataUri(icons.boomIcon)}');
    background-repeat: no-repeat;
    width: 60px;
    height: 13px;
    margin: 10px 0;
    display: block;
  }

  :global(.csicon-arrow_right) {
    margin-left: 10px;
  }

  .add-to-cart-wrapper {
    display: flex;
  }

  .multipurpose-badge {
    width: 100%;
    margin-bottom: 24px;
  }
  .variant-seller-ids {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
`;

export { ProductSpecificationsMobileStyle };
